import { useTranslation } from 'react-i18next';
import { Icon } from 'src/components/atoms/Icon';
import Tile from 'src/components/DUP/atoms/Tile/Tile';
import ConnectedAccountsList from 'src/components/DUP/molecules/ConnectedAccountsList/ConnectedAccountsList';
import { useApplication } from 'src/context/ApplicationContext';
import { ARGYLE_HOW_TO_VIDEO_URL } from 'src/features/DUP';
import { HowToLink } from './styles';

const CONNECTED_PAYROLL_TRANSLATION_PREFIX = 'dup.wizard.connectPayrollTile';

export const ConnectedPayrollTile = () => {
  const { t } = useTranslation();

  const {
    connectedPayroll: {
      connectArgyle,
      accountsConnected,
      isLoadingAccounts,
      isDeletingAccounts,
      disconnectAccount,
      loadingArgyle
    }
  } = useApplication();

  const showLoadingIndicator = isLoadingAccounts || isDeletingAccounts || loadingArgyle;

  const content =
    !showLoadingIndicator && !!accountsConnected?.length ? (
      <ConnectedAccountsList
        connectedAccounts={accountsConnected}
        disconnectAccount={disconnectAccount}
      />
    ) : (
      [
        <>
          {t(`${CONNECTED_PAYROLL_TRANSLATION_PREFIX}.text.1`)}
          <HowToLink href={ARGYLE_HOW_TO_VIDEO_URL} target="_blank" rel="noopener noreferrer">
            {t('dup.wizard.learnMore')}
          </HowToLink>
        </>,
        t(`${CONNECTED_PAYROLL_TRANSLATION_PREFIX}.text.2`)
      ]
    );

  return (
    <Tile
      title={t(`${CONNECTED_PAYROLL_TRANSLATION_PREFIX}.title`)}
      subtitle={t(`${CONNECTED_PAYROLL_TRANSLATION_PREFIX}.subtitle`)}
      icon={<Icon icon="check-recommended" />}
      button={{
        isLoading: showLoadingIndicator,
        isDisabled: showLoadingIndicator,
        onClick: () => connectArgyle(),
        children: accountsConnected?.length ? t('dup.wizard.connectAdditionalAccounts') : undefined
      }}
      content={content}
    />
  );
};

export default ConnectedPayrollTile;
